import { ordersClient } from "@core/clients";
import { TOrder } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

const UNREVIEWED_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS = 60 * 1000; // 1 minute

const useGetUnreviewedOrdersId = (options?: UseQueryOptions<TOrder["id"][], any, TOrder["id"][], string[]>) => {
  return useQuery(
    ["orders-unreviewed"],
    async () => {
      return await ordersClient.getUnreviewedOrdersId();
    },
    {
      cacheTime: UNREVIEWED_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: UNREVIEWED_ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...options,
    }
  );
};

export default useGetUnreviewedOrdersId;
